import { Injectable } from '@angular/core';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { DateTime } from 'luxon';

@Injectable()
export class CustomLuxonDateAdapter extends LuxonDateAdapter {
  override parse(value: any): DateTime | null {
    if (!value) return null;

    const normalizedValue = value.toString().replace(/\s+/g, '').toLowerCase();

    if (/^\d{2}\s\d{2}\s\d{4}$/.test(value)) {
      const [day, month, year]: string[] = value.split(' ');
      return DateTime.fromObject({ day: +day, month: +month, year: +year });
    }

    if (/^\d{8}$/.test(normalizedValue)) {
      const day = +normalizedValue.substring(0, 2);
      const month = +normalizedValue.substring(2, 4);
      const year = +normalizedValue.substring(4, 8);
      return DateTime.fromObject({ day, month, year });
    }

    if (/^\d{2}\s[a-z]{3}\s\d{4}$/.test(normalizedValue)) {
      const [day, month, year]: string[] = value.split(' ');
      return DateTime.fromObject({ day: +day, month: this.getMonthIndex(month), year: +year });
    }

    if (/^\d{2}[a-z]{3}\d{4}$/.test(normalizedValue)) {
      const day = +normalizedValue.substring(0, 2);
      const month = normalizedValue.substring(2, 5);
      const year = +normalizedValue.substring(5, 9);
      return DateTime.fromObject({ day, month: this.getMonthIndex(month), year: +year });
    }

    if (/^\d{4}$/.test(normalizedValue)) {
      const day = +normalizedValue.substring(0, 2);
      const month = +normalizedValue.substring(2, 4);
      const today = DateTime.now();
      const currentYear = today.year;

      const inputDate = DateTime.fromObject({ day, month, year: currentYear });
      const year = inputDate < today ? currentYear + 1 : currentYear;

      return DateTime.fromObject({ day, month, year });
    }

    return null;
  }

  private getMonthIndex(month: string): number {
    const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    return months.indexOf(month.toLowerCase()) + 1;
  }
}
